// Note: Nations_ISO3166_1_Alpha3
export const NATIONS: Array<Object> = [
  { text: 'Japan', value: 'JP' },
  { text: 'Afghanistan', value: 'AF' },
  { text: 'Albania', value: 'AL' },
  { text: 'Algeria', value: 'DZ' },
  { text: 'AmericanSamoa', value: 'AS' },
  { text: 'Andorra', value: 'AD' },
  { text: 'Angola', value: 'AO' },
  { text: 'Anguilla', value: 'AI' },
  { text: 'Antarctica', value: 'AQ' },
  { text: 'AntiguaandBarbuda', value: 'AG' },
  { text: 'Argentina', value: 'AR' },
  { text: 'Armenia', value: 'AM' },
  { text: 'Aruba', value: 'AW' },
  { text: 'Australia', value: 'AU' },
  { text: 'Austria', value: 'AT' },
  { text: 'Azerbaijan', value: 'AZ' },
  { text: 'Bahamas', value: 'BS' },
  { text: 'Bahrain', value: 'BH' },
  { text: 'Bangladesh', value: 'BD' },
  { text: 'Barbados', value: 'BB' },
  { text: 'Belarus', value: 'BY' },
  { text: 'Belgium', value: 'BE' },
  { text: 'Belize', value: 'BZ' },
  { text: 'Benin', value: 'BJ' },
  { text: 'Bermuda', value: 'BM' },
  { text: 'Bhutan', value: 'BT' },
  { text: 'Bolivia', value: 'BO' },
  { text: 'BonaireSintEustatiusandSaba', value: 'BQ' },
  { text: 'BosniaandHerzegovina', value: 'BA' },
  { text: 'Botswana', value: 'BW' },
  { text: 'BouvetIsland', value: 'BV' },
  { text: 'Brazil', value: 'BR' },
  { text: 'BritishIndianOceanTerritory', value: 'IO' },
  { text: 'BruneiDarussalam', value: 'BN' },
  { text: 'Bulgaria', value: 'BG' },
  { text: 'BurkinaFaso', value: 'BF' },
  { text: 'Burundi', value: 'BI' },
  { text: 'CaboVerde', value: 'CV' },
  { text: 'Cambodia', value: 'KH' },
  { text: 'Cameroon', value: 'CM' },
  { text: 'Canada', value: 'CA' },
  { text: 'CaymanIslands', value: 'KY' },
  { text: 'CentralAfricanRepublic', value: 'CF' },
  { text: 'Chad', value: 'TD' },
  { text: 'Chile', value: 'CL' },
  { text: 'China', value: 'CN' },
  { text: 'ChristmasIsland', value: 'CX' },
  { text: 'CocosIslands', value: 'CC' },
  { text: 'Colombia', value: 'CO' },
  { text: 'Comoros', value: 'KM' },
  { text: 'CongoDemocraticRepublicofthe', value: 'CD' },
  { text: 'Congo', value: 'CG' },
  { text: 'CookIslands', value: 'CK' },
  { text: 'CostaRica', value: 'CR' },
  { text: 'Croatia', value: 'HR' },
  { text: 'Cuba', value: 'CU' },
  { text: 'Curacao', value: 'CW' },
  { text: 'Cyprus', value: 'CY' },
  { text: 'Czechia', value: 'CZ' },
  { text: "CotedIvoire", value: 'CI' },
  { text: 'Denmark', value: 'DK' },
  { text: 'Djibouti', value: 'DJ' },
  { text: 'Dominica', value: 'DM' },
  { text: 'DominicanRepublic', value: 'DO' },
  { text: 'Ecuador', value: 'EC' },
  { text: 'Egypt', value: 'EG' },
  { text: 'ElSalvador', value: 'SV' },
  { text: 'EquatorialGuinea', value: 'GQ' },
  { text: 'Eritrea', value: 'ER' },
  { text: 'Estonia', value: 'EE' },
  { text: 'Eswatini', value: 'SZ' },
  { text: 'Ethiopia', value: 'ET' },
  { text: 'FalklandIslands', value: 'FK' },
  { text: 'FaroeIslands', value: 'FO' },
  { text: 'Fiji', value: 'FJ' },
  { text: 'Finland', value: 'FI' },
  { text: 'France', value: 'FR' },
  { text: 'FrenchGuiana', value: 'GF' },
  { text: 'FrenchPolynesia', value: 'PF' },
  { text: 'FrenchSouthernTerritories', value: 'TF' },
  { text: 'Gabon', value: 'GA' },
  { text: 'Gambia', value: 'GM' },
  { text: 'Georgia', value: 'GE' },
  { text: 'Germany', value: 'DE' },
  { text: 'Ghana', value: 'GH' },
  { text: 'Gibraltar', value: 'GI' },
  { text: 'Greece', value: 'GR' },
  { text: 'Greenland', value: 'GL' },
  { text: 'Grenada', value: 'GD' },
  { text: 'Guadeloupe', value: 'GP' },
  { text: 'Guam', value: 'GU' },
  { text: 'Guatemala', value: 'GT' },
  { text: 'Guernsey', value: 'GG' },
  { text: 'Guinea', value: 'GN' },
  { text: 'GuineaBissau', value: 'GW' },
  { text: 'Guyana', value: 'GY' },
  { text: 'Haiti', value: 'HT' },
  { text: 'HeardIslandandMcDonaldIslands', value: 'HM' },
  { text: 'HolySee', value: 'VA' },
  { text: 'Honduras', value: 'HN' },
  { text: 'HongKong', value: 'HK' },
  { text: 'Hungary', value: 'HU' },
  { text: 'Iceland', value: 'IS' },
  { text: 'India', value: 'IN' },
  { text: 'Indonesia', value: 'ID' },
  { text: 'Iran', value: 'IR' },
  { text: 'Iraq', value: 'IQ' },
  { text: 'Ireland', value: 'IE' },
  { text: 'IsleofMan', value: 'IM' },
  { text: 'Israel', value: 'IL' },
  { text: 'Italy', value: 'IT' },
  { text: 'Jamaica', value: 'JM' },
  { text: 'Jersey', value: 'JE' },
  { text: 'Jordan', value: 'JO' },
  { text: 'Kazakhstan', value: 'KZ' },
  { text: 'Kenya', value: 'KE' },
  { text: 'Kiribati', value: 'KI' },
  { text: 'NorthKorea', value: 'KP' },
  { text: 'Korea', value: 'KR' },
  { text: 'Kuwait', value: 'KW' },
  { text: 'Kyrgyzstan', value: 'KG' },
  { text: "LaoPeoplesDemocraticRepublic", value: 'LA' },
  { text: 'Latvia', value: 'LV' },
  { text: 'Lebanon', value: 'LB' },
  { text: 'Lesotho', value: 'LS' },
  { text: 'Liberia', value: 'LR' },
  { text: 'Libya', value: 'LY' },
  { text: 'Liechtenstein', value: 'LI' },
  { text: 'Lithuania', value: 'LT' },
  { text: 'Luxembourg', value: 'LU' },
  { text: 'Macao', value: 'MO' },
  { text: 'Madagascar', value: 'MG' },
  { text: 'Malawi', value: 'MW' },
  { text: 'Malaysia', value: 'MY' },
  { text: 'Maldives', value: 'MV' },
  { text: 'Mali', value: 'ML' },
  { text: 'Malta', value: 'MT' },
  { text: 'MarshallIslands', value: 'MH' },
  { text: 'Martinique', value: 'MQ' },
  { text: 'Mauritania', value: 'MR' },
  { text: 'Mauritius', value: 'MU' },
  { text: 'Mayotte', value: 'YT' },
  { text: 'Mexico', value: 'MX' },
  { text: 'Micronesia', value: 'FM' },
  { text: 'Moldova', value: 'MD' },
  { text: 'Monaco', value: 'MC' },
  { text: 'Mongolia', value: 'MN' },
  { text: 'Montenegro', value: 'ME' },
  { text: 'Montserrat', value: 'MS' },
  { text: 'Morocco', value: 'MA' },
  { text: 'Mozambique', value: 'MZ' },
  { text: 'Myanmar', value: 'MM' },
  { text: 'Namibia', value: 'NA' },
  { text: 'Nauru', value: 'NR' },
  { text: 'Nepal', value: 'NP' },
  { text: 'Netherlands', value: 'NL' },
  { text: 'NewCaledonia', value: 'NC' },
  { text: 'NewZealand', value: 'NZ' },
  { text: 'Nicaragua', value: 'NI' },
  { text: 'Niger', value: 'NE' },
  { text: 'Nigeria', value: 'NG' },
  { text: 'Niue', value: 'NU' },
  { text: 'NorfolkIsland', value: 'NF' },
  { text: 'NorthMacedonia', value: 'MK' },
  { text: 'NorthernMarianaIslands', value: 'MP' },
  { text: 'Norway', value: 'NO' },
  { text: 'Oman', value: 'OM' },
  { text: 'Pakistan', value: 'PK' },
  { text: 'Palau', value: 'PW' },
  { text: 'Palestine', value: 'PS' },
  { text: 'Panama', value: 'PA' },
  { text: 'PapuaNewGuinea', value: 'PG' },
  { text: 'Paraguay', value: 'PY' },
  { text: 'Peru', value: 'PE' },
  { text: 'Philippines', value: 'PH' },
  { text: 'Pitcairn', value: 'PN' },
  { text: 'Poland', value: 'PL' },
  { text: 'Portugal', value: 'PT' },
  { text: 'PuertoRico', value: 'PR' },
  { text: 'Qatar', value: 'QA' },
  { text: 'Romania', value: 'RO' },
  { text: 'RussianFederation', value: 'RU' },
  { text: 'Rwanda', value: 'RW' },
  { text: 'Reunion', value: 'RE' },
  { text: 'SaintBarthelemy', value: 'BL' },
  { text: 'SaintHelena', value: 'SH' },
  { text: 'SaintKittsandNevis', value: 'KN' },
  { text: 'SaintLucia', value: 'LC' },
  { text: 'SaintMartin', value: 'MF' },
  { text: 'SaintPierreandMiquelon', value: 'PM' },
  { text: 'SaintVincentandtheGrenadines', value: 'VC' },
  { text: 'Samoa', value: 'WS' },
  { text: 'SanMarino', value: 'SM' },
  { text: 'SaoTomeandPrincipe', value: 'ST' },
  { text: 'SaudiArabia', value: 'SA' },
  { text: 'Senegal', value: 'SN' },
  { text: 'Serbia', value: 'RS' },
  { text: 'Seychelles', value: 'SC' },
  { text: 'SierraLeone', value: 'SL' },
  { text: 'Singapore', value: 'SG' },
  { text: 'SintMaarten', value: 'SX' },
  { text: 'Slovakia', value: 'SK' },
  { text: 'Slovenia', value: 'SI' },
  { text: 'SolomonIslands', value: 'SB' },
  { text: 'Somalia', value: 'SO' },
  { text: 'SouthAfrica', value: 'ZA' },
  { text: 'SouthGeorgiaandtheSouthSandwichIslands', value: 'GS' },
  { text: 'SouthSudan', value: 'SS' },
  { text: 'Spain', value: 'ES' },
  { text: 'SriLanka', value: 'LK' },
  { text: 'Sudan', value: 'SD' },
  { text: 'Suriname', value: 'SR' },
  { text: 'SvalbardandJanMayen', value: 'SJ' },
  { text: 'Sweden', value: 'SE' },
  { text: 'Switzerland', value: 'CH' },
  { text: 'SyrianArabRepublic', value: 'SY' },
  { text: 'Taiwan', value: 'TW' },
  { text: 'Tajikistan', value: 'TJ' },
  { text: 'Tanzania', value: 'TZ' },
  { text: 'Thailand', value: 'TH' },
  { text: 'TimorLeste', value: 'TL' },
  { text: 'Togo', value: 'TG' },
  { text: 'Tokelau', value: 'TK' },
  { text: 'Tonga', value: 'TO' },
  { text: 'TrinidadandTobago', value: 'TT' },
  { text: 'Tunisia', value: 'TN' },
  { text: 'Turkey', value: 'TR' },
  { text: 'Turkmenistan', value: 'TM' },
  { text: 'TurksandCaicosIslands', value: 'TC' },
  { text: 'Tuvalu', value: 'TV' },
  { text: 'Uganda', value: 'UG' },
  { text: 'Ukraine', value: 'UA' },
  { text: 'UnitedArabEmirates', value: 'AE' },
  { text: 'UnitedKingdomofGreatBritainandNorthernIreland', value: 'GB'},
  { text: 'UnitedStatesMinorOutlyingIslands', value: 'UM' },
  { text: 'UnitedStatesofAmerica', value: 'US' },
  { text: 'Uruguay', value: 'UY' },
  { text: 'Uzbekistan', value: 'UZ' },
  { text: 'Vanuatu', value: 'VU' },
  { text: 'Venezuela', value: 'VE' },
  { text: 'VietNam', value: 'VN' },
  { text: 'VirginIslandsBritish', value: 'VG' },
  { text: 'VirginIslandsUS', value: 'VI' },
  { text: 'WallisandFutuna', value: 'WF' },
  { text: 'WesternSahara', value: 'EH' },
  { text: 'Yemen', value: 'YE' },
  { text: 'Zambia', value: 'ZM' },
  { text: 'Zimbabwe', value: 'ZW' },
  { text: 'AlandIslands', value: 'AX' }
]

export default {
  NATIONS
}
